import { Routes, Route, Navigate } from "react-router-dom";
import { Shell } from "../../components/Shell";
import { useLang } from "../../lib/i18n";
import { LayoutDashboard, Building2, KanbanSquare, ReceiptText, Handshake, Gauge } from "lucide-react";
import Overview from "./Overview";
import Tenants from "./Tenants";
import TenantView from "./TenantView";
import Crm from "./Crm";
import Billing from "./Billing";
import Resellers from "./Resellers";
import Usage from "./Usage";

export default function PlatformApp() {
  const { t } = useLang();
  const items = [
    { to: "/platform", end: true, icon: LayoutDashboard, label: t("dash.overview"), testid: "nav-platform-overview" },
    { to: "/platform/tenants", icon: Building2, label: t("dash.tenants"), testid: "nav-platform-tenants" },
    { to: "/platform/crm", icon: KanbanSquare, label: t("dash.crm"), testid: "nav-platform-crm" },
    { to: "/platform/billing", icon: ReceiptText, label: t("dash.billing"), testid: "nav-platform-billing" },
    { to: "/platform/resellers", icon: Handshake, label: t("dash.resellers"), testid: "nav-platform-resellers" },
    { to: "/platform/usage", icon: Gauge, label: t("dash.usage"), testid: "nav-platform-usage" },
  ];
  return (
    <Shell items={items} brand="KOPERA" subtitle="Platform Admin" testid="platform-admin-portal">
      <Routes>
        <Route index element={<Overview />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="tenants/:tenantId" element={<TenantView />} />
        <Route path="crm" element={<Crm />} />
        <Route path="billing" element={<Billing />} />
        <Route path="resellers" element={<Resellers />} />
        <Route path="usage" element={<Usage />} />
        <Route path="*" element={<Navigate to="/platform" replace />} />
      </Routes>
    </Shell>
  );
}
